import { useTranslation } from 'react-i18next'
import { Col, Form, Row } from 'antd'

import B2becCustomSelect from '@/components/B2becCustomSelect'
import B2becTranslation from '@/components/B2becTranslation'
import { useAppSelector } from '@/store/hook'
import {
  selectAssignableCountries,
  selectAssignableCountryRolesList,
} from '@/store/selectors/roleSelector'
import { useAssignRoles } from '@/hooks/useAssignRoles'
import { isValidArray } from '@/libs/utils/array'

import CustomButton from '../CustomButton'
import { DeleteBorderlessIcon, PlusIcon } from '../Icons'
import styles from './B2becAssignRole.module.scss'

const B2becAssignRole = () => {
  const { findAssignableRoles, firstCountryValue, assignedRoles } = useAssignRoles()
  const assignableCountryRolesList = useAppSelector(
    selectAssignableCountryRolesList,
  )
  const assignableCountries = useAppSelector(selectAssignableCountries)
  const { t } = useTranslation()

  return (
    <Col span={24}>
      <Form.Item required label={t('form.label.assignRoles')} className="custom-form-item">
        <Form.List
          className="b2b-user-form__assign-roles"
          name="countryRoles"
          rules={[
            {
              async validator(_, countryRoles) {
                let roles = {}
                // For technical users
                if (isValidArray(countryRoles)) {
                  const [data] = countryRoles
                  roles = data?.roles
                } else {
                  // For normal customers
                  roles = countryRoles?.roles
                }

                const shouldDisplayRequiredMessage = !isValidArray(assignedRoles)
                  && !isValidArray(roles)

                if (shouldDisplayRequiredMessage) {
                  throw new Error(t('form.error.requiredField'))
                }

                return
              },
            },
          ]}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, ...field }, index) => {
                return (
                  <Col key={key} span={24}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item {...field} name={[field.name, 'salesOrg']}>
                          <B2becCustomSelect options={assignableCountries} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          {...field}
                          name={[field.name, 'roles']}
                          rules={[
                            {
                              required: true,
                              message: (
                                <B2becTranslation
                                  value="form.validate.required"
                                  variables={{ label: 'assignRoles' }}
                                />
                              ),
                            },
                          ]}
                        >
                          <B2becCustomSelect
                            mode="multiple"
                            optionLabelProp="label"
                            options={findAssignableRoles(firstCountryValue)}
                            suffixIcon={null}
                          />
                        </Form.Item>
                      </Col>
                      {index > 0 && (
                        <DeleteBorderlessIcon
                          className={styles.minusButton}
                          onClick={() => {
                            remove(field.name)
                          }}
                        />
                      )}
                    </Row>
                  </Col>
                )
              })}
              {((isValidArray(assignableCountryRolesList)
                && fields?.length === 0)
                || (isValidArray(assignableCountryRolesList, 1)
                  && fields?.length < assignableCountryRolesList?.length)) && (
                <Col span={24}>
                  <Form.Item>
                    <CustomButton
                      buttonSize="small"
                      className={styles.addButton}
                      type="ghost"
                      onClick={() => add()}
                    >
                      <PlusIcon /> {t('form.label.addRole')}
                    </CustomButton>
                  </Form.Item>
                </Col>
              )}
            </>
          )}
        </Form.List>
      </Form.Item>
    </Col>
  )
}
export default B2becAssignRole
